"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeRefs = exports.passThroughRule = exports.rem = void 0;
var rem = function (size, base) { return "".concat(size * base, "rem"); };
exports.rem = rem;
var passThroughRule = function (rule, value) {
    return value !== undefined ? "".concat(rule, ": ").concat(value, ";") : '';
};
exports.passThroughRule = passThroughRule;
function mergeRefs() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    var filteredRefs = refs.filter(Boolean);
    if (!filteredRefs.length)
        return null;
    if (filteredRefs.length === 0)
        return filteredRefs[0];
    return function (instance) {
        for (var _i = 0, filteredRefs_1 = filteredRefs; _i < filteredRefs_1.length; _i++) {
            var ref = filteredRefs_1[_i];
            if (typeof ref === 'function') {
                ref(instance);
            }
            else if (ref) {
                ref.current = instance;
            }
        }
    };
}
exports.mergeRefs = mergeRefs;
//# sourceMappingURL=helpers.js.map